module.exports = __webpack_public_path__ + "static/img/certificate6.881d4dd1.png";